export default __webpack_public_path__ + "static/media/latest-news-img13.bfd72968.jpg";